import { z } from 'zod'
import { oc } from '@orpc/contract'

export const patientLabOrder = oc
  .route({ method: 'GET', path: '/v2/patient/me/lab-order/{orderId}' })
  .input(z.object({ orderId: z.string().min(1) }))
  .output(
    z.object({
      order: z
        .object({
          title: z.string(),
          performer: z.string().nullable(),
          orderedOn: z.string().nullable(),
          document: z
            .object({
              filename: z.string(),
              contentType: z.string(),
              base64: z.string(),
            })
            .nullable(),
        })
        .nullable(),
    }),
  )
